import React from 'react';
import { Box } from '@mui/material';
import { ProfileInfo } from '../../../../../packages/ui/templates/profile-info';
import { Icons, IconText } from '../../../../../packages';
import { useStyles } from './LoeAssignmentsDrawer.styles';

export const MemberInfo = ({ profileImage, nickName, fullName, goToChat, type, memberId }) => {
  const classes = useStyles();
  return (
    <Box className={classes.memberInfoContainer}>
      <Box className={classes.profileContainer}>
        <ProfileInfo
          type="member"
          photo={profileImage}
          nickName={nickName}
          fullName={fullName}
          memberId={memberId}
        />
      </Box>
      {type !== 'Signup incomplete' && (
        <Box className={classes.iconTextContainer} onClick={goToChat}>
          <Icons glyph="chat-icon" className={classes.icon} />
          <IconText>Go to chat</IconText>
        </Box>
      )}
    </Box>
  );
};
